var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8040)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8040",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 0.976563C23.3736 0.976252 21.7516 1.13984 20.1583 1.46484C17.0854 2.0942 14.1665 3.32248 11.5681 5.07959C7.70577 7.68681 4.68237 11.3582 2.86423 15.6488C2.25 17.1021 1.78118 18.6126 1.46462 20.1583C0.813877 23.3532 0.813877 26.6464 1.46462 29.8413C2.09396 32.9142 3.32224 35.8331 5.07936 38.4314C7.68669 42.2938 11.3581 45.3171 15.6489 47.1352C17.1021 47.7495 18.6125 48.2185 20.1581 48.5352C23.3529 49.1859 26.6462 49.1859 29.8411 48.5352C32.914 47.9058 35.8329 46.6775 38.4312 44.9204C42.2936 42.3131 45.3169 38.6416 47.1349 34.3509C47.7493 32.8976 48.2183 31.387 48.5349 29.8413C49.1857 26.6464 49.1857 23.3532 48.5349 20.1583C47.9056 17.0854 46.6773 14.1665 44.9202 11.5682C42.3128 7.70579 38.6413 4.68244 34.3505 2.86445C32.8972 2.25023 31.3867 1.78141 29.8411 1.46484C28.2478 1.13985 26.6259 0.976267 24.9998 0.976563ZM25.075 17.959C24.4939 17.959 23.9996 17.771 23.6456 17.4154C23.4822 17.2479 23.3538 17.0495 23.2677 16.8319C23.1817 16.6143 23.1397 16.3817 23.1443 16.1478C23.1443 16.1229 23.1443 16.1024 23.1451 16.0838C23.1451 14.9729 23.9096 14.1972 25.0044 14.1972C25.2537 14.1915 25.5017 14.2364 25.7332 14.3291C25.9648 14.4219 26.1751 14.5607 26.3515 14.737C26.5279 14.9134 26.6668 15.1237 26.7596 15.3552C26.8525 15.5867 26.8975 15.8346 26.8919 16.084V16.101C26.8919 17.1603 26.1107 17.959 25.0748 17.959H25.075ZM23.5003 35.1516V21.111L26.5146 21.0125V35.1516H23.5003Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoFilled);
export default __webpack_public_path__ + "static/media/info_filled.1968048348b90dd40d2caa6d6bcdb8a5.svg";
export { ForwardRef as ReactComponent };